import script from "./DistrictSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./DistrictSelect.vue?vue&type=script&lang=ts&setup=true"

import "./DistrictSelect.vue?vue&type=style&index=0&id=30f85ac0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30f85ac0"]])

export default __exports__